import { animated, useTrail } from "react-spring";

import React from "react";
import VerticalThumbnail from "../VerticalThumbnail";
import { VerticalThumbnailProps } from "../VerticalThumbnail/VerticalThumbnail";

export interface VerticalThumbnailGridProps {
  items: VerticalThumbnailProps[];
}

const VerticalThumbnailGrid = ({ items }: VerticalThumbnailGridProps) => {
  // Fade in up animation
  const fadeInUpTrail = useTrail(items.length, {
    opacity: 1,
    transform: "translateY(0px)",
    from: {
      opacity: 0,
      transform: "translateY(10px)",
    },
  });

  return (
    <div className="flex flex-wrap justify-start w-full">
      {items.length ? (
        items.map((item, key) => (
          <animated.div
            className="w-1/2 px-2 py-6 sm:w-4/12 md:w-3/12 lg:w-2/12"
            style={fadeInUpTrail[key]}
            key={key}
          >
            <VerticalThumbnail {...item} />
          </animated.div>
        ))
      ) : (
        <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
          No items available.
        </div>
      )}
    </div>
  );
};

export default VerticalThumbnailGrid;
